import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4 text-blue-400 break-words">おかやま放課後等デイサービス</h3>
            <div className="space-y-1 sm:space-y-2 text-sm sm:text-base text-gray-300">
              <p>〒700-0000</p>
              <p className="break-words">岡山市北区○○町1-2-3</p>
              <p>TEL: 086-012-3456</p>
              <p>FAX: 086-012-3457</p>
              <p>営業時間: 9:00 〜 18:00</p>
              <p>定休日: 日曜日・祝日</p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4 text-blue-400">サイトマップ</h3>
            <nav className="space-y-1 sm:space-y-2">
              <Link to="/" className="block text-sm sm:text-base text-gray-300 hover:text-white cursor-pointer">
                ホーム
              </Link>
              <Link to="/services" className="block text-sm sm:text-base text-gray-300 hover:text-white cursor-pointer">
                事業内容
              </Link>
              <Link to="/about" className="block text-sm sm:text-base text-gray-300 hover:text-white cursor-pointer">
                会社概要
              </Link>
              <Link to="/recruit" className="block text-sm sm:text-base text-gray-300 hover:text-white cursor-pointer">
                求人情報
              </Link>
              <Link to="/blog" className="block text-sm sm:text-base text-gray-300 hover:text-white cursor-pointer">
                ブログ・新着情報
              </Link>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4 text-blue-400">お問い合わせ</h3>
            <div className="space-y-3 sm:space-y-4">
              <a
                href="tel:086-012-3456"
                className="flex items-center space-x-2 text-sm sm:text-base text-green-400 hover:text-green-300 cursor-pointer"
              >
                <i className="ri-phone-fill flex-shrink-0"></i>
                <span>お電話でのお問い合わせ</span>
              </a>
              <p className="text-xs sm:text-sm text-gray-300">
                お気軽にお電話ください。<br />
                見学・相談は随時受け付けております。
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-6 sm:mt-8 pt-6 sm:pt-8 text-center">
          <p className="text-xs sm:text-sm text-gray-400 break-words px-2">
            &copy; 2024 おかやま放課後等デイサービス. All rights reserved. | 
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-400 hover:text-blue-300 ml-2 cursor-pointer"
            >
              Website Builder
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
